module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate22.91b21c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate22.png
// module id = 758
// module chunks = 0